import {
  AnimatedImagePresetDto,
  DeleteAnimatedImagePresetResponseDto,
  PagedAnimatedImagePresetsRequestDto,
  PagedAnimatedImagePresetsResponseDto,
  SetAnimatedImagePresetFavouriteDto,
  UpdateAnimatedImagePresetDto,
} from "@repo/api/animated-image-preset";
import { AmplifilesClient } from "./api-client";

export class AnimatedImagePresetApi {
  static async getPagedAnimatedImagePresets(
    teamExternalId: string,
    body: PagedAnimatedImagePresetsRequestDto,
  ): Promise<PagedAnimatedImagePresetsResponseDto> {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/animated-image-presets-paged`,
      body,
    );

    return PagedAnimatedImagePresetsResponseDto.parse(response.data);
  }

  static async updateAnimatedImagePreset(
    teamExternalId: string,
    presetExternalId: string,
    data: UpdateAnimatedImagePresetDto,
  ): Promise<AnimatedImagePresetDto> {
    const response = await AmplifilesClient.instance.put(
      `/team/${teamExternalId}/animated-image-preset/${presetExternalId}`,
      data,
    );

    return AnimatedImagePresetDto.parse(response.data);
  }

  static async deleteAnimatedImagePreset(
    teamExternalId: string,
    presetExternalId: string,
  ): Promise<DeleteAnimatedImagePresetResponseDto> {
    const response = await AmplifilesClient.instance.delete(
      `/team/${teamExternalId}/animated-image-preset/${presetExternalId}`,
    );

    return DeleteAnimatedImagePresetResponseDto.parse(response.data);
  }

  static async setAnimatedImagePresetFavourite(
    teamExternalId: string,
    presetExternalId: string,
    data: SetAnimatedImagePresetFavouriteDto,
  ): Promise<AnimatedImagePresetDto> {
    const response = await AmplifilesClient.instance.put(
      `/team/${teamExternalId}/animated-image-preset/${presetExternalId}/favourite`,
      data,
    );

    return AnimatedImagePresetDto.parse(response.data);
  }
}
